import React from 'react';
export const HomeScreen = ({
  onGetStarted,
  onResumeApplication
}) => {
  return <div className="flex flex-col items-center justify-center p-6 flex-grow bg-gray-50" data-id="element-164">
      <div className="w-full max-w-md mx-auto flex flex-col items-center" data-id="element-165">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7Frqi3Qp7tZbKVGUnkz12Q/Screenshot_2025-08-08_at_5.52.22_PM.png" alt="Veritran Logo" className="w-48 mb-8" data-id="element-166" />
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-4" data-id="element-167">
          Veritran Digital Account Opening
        </h1>
        <p className="text-gray-600 text-center mb-10" data-id="element-168">
          Welcome to a simpler way to open your new financial accounts. Get
          started in just a few minutes.
        </p>
        <button className="w-full bg-[#5c5cf5] text-white py-4 rounded-full font-medium text-lg shadow-md hover:bg-[#4a4ad3] transition-colors mb-4" onClick={onGetStarted} data-id="element-169">
          Get Started
        </button>
        <button className="w-full bg-white border border-[#5c5cf5] text-[#5c5cf5] py-3 rounded-full font-medium shadow-sm hover:bg-gray-50 transition-colors" onClick={onResumeApplication} data-id="element-170">
          Resume my Application
        </button>
      </div>
    </div>;
};